import React, { useContext } from "react";
import { Stack, Typography } from "@mui/material";
import { styles } from "../../../screens/DashboardScreen/News/news.styles";
import { LanguageContext } from "../../../hooks/LanguageContext";
import { useTranslateKey } from "../../../hooks/useTranslate";
import { formatDate } from "../../../common/newsDateUtils";
import DOMPurify from 'dompurify';
import { setAttributesForHtml } from "../../../common/newsHtmlUtils";

const ArticleDetailView = ({ article }) => {
  const { currentLanguage } = useContext(LanguageContext);

  const todayTranslated = useTranslateKey("today");
  const yesterdayTranslated = useTranslateKey("yesterday");
  const dateString = article.lastEditedAt;
  const displayDate = formatDate(dateString, currentLanguage, todayTranslated, yesterdayTranslated);

  const cleanHTML = DOMPurify.sanitize(article.content);
  const formattedHTML = setAttributesForHtml(cleanHTML, 12);

  return (
    <Stack mt={2}>
      <Stack alignItems="center">
        {
          article.imageUrl && (
            <img
              src={article.imageUrl}
              alt="main"
              height="327px"
              width="100%"
              style={{ borderRadius: '12px', maxWidth: "327px" }}
            />
          )
        }
      </Stack>
      <Typography mt={3} sx={styles.articleViewItemName}>
        {article.title}
      </Typography>
      <Typography variant="widgetItemIimestamp">
        {displayDate && displayDate}
      </Typography>
      <Typography dangerouslySetInnerHTML={{ __html: formattedHTML }} />
    </Stack>
  )
}

export { ArticleDetailView }